module.exports = __webpack_public_path__ + "static/media/savetime.3b3c33ea.svg";